import { Tag } from '@lokalise/louis';
import { excludeProps } from '@lokalise/styled';

import styled, { css } from '@app/styled';
import { withLinkStyle } from '@app/styles';
import { color, modifier, radius, spacing } from '@app/theme';

export const Badge = styled.div`
    position: absolute;
    top: 5px;
    right: -13px;
    background-color: ${color('custom.red.500')};
    font-size: 8px;
    color: ${color('custom.content.white')};
    border-radius: ${radius('rounded')};
    width: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
`;

export const withNavLinkStyle = css<{ active?: boolean }>`
    ${withLinkStyle};
    display: block;
    position: relative;
    color: inherit;
    padding-top: ${spacing(2)};
    padding-bottom: 14px;
    background-color: transparent !important;

    ${modifier(
        'active',
        css`
            color: ${color('custom.interactive.primary.hover')};
        `,
    )}

    &[disabled] {
        pointer-events: none; // Fixes issue with mouseLeave not firing after tooltip is shown
    }
`;

export const NavLink = styled.a.withConfig({
    shouldForwardProp: excludeProps(['active']),
})<{ active?: boolean }>`
    ${withNavLinkStyle};
`;

export const NavButton = styled.button.withConfig({
    shouldForwardProp: excludeProps(['active']),
})<{ active?: boolean }>`
    ${withNavLinkStyle};

    ${modifier(
        'disabled',
        css`
            color: ${color('custom.interactive.content.disabled')};
        `,
    )}
`;

export const NewTag = styled(Tag)`
    background: ${color('background.active')};
    border: none;
    color: ${color('background.action.primary.pressed')};
`;
